import { usePlanFinderDialogStore } from '@/stores/plan-finder-dialog'

import { PlanFinderDialog } from './plan-finder-dialog'

export function PlanFinderDialogProvider() {
  const { isOpen, setIsOpen } = usePlanFinderDialogStore()

  return <PlanFinderDialog open={isOpen} onOpenChange={setIsOpen} />
}
